import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import auth from "@/store/modules/auth.module";

Vue.use(Vuex)

const state = {
  userDetails : null,
  currentGiftcard : null
}

const getters = {
  getUserDetails: (state) => {
    return state.userDetails;
  },
}

const mutations = {
  updateUser(state, user) {
    const { userDetails: currentUser } = state;
    let newUser = { ...currentUser, ...user };
    state.userDetails = newUser;
  },
  storeUser(state, user) {
    state.userDetails = user;
  },
  setUserDetails(state, payload) {
    state.userDetails = payload;
  },
  setCurrentGiftcard(state, payload){
    state.currentGiftcard = payload
  },
  removeUser(state, user) {
    state.userDetails = user;
  },

}

const actions = {
  toast(context, data) {
    if(data.message){
      let variant = data.variant;
      this._vm.$toast[variant](data.message)
    }
  },
  setUserInfo({ commit }, credentials) {
    commit("setUserDetails", credentials);
  },
  saveUserSecret({ commit }, secret) {
    commit("setUserSecret", secret)
  },
  setCurrentGiftcard({ commit }, credentials){
    commit("setCurrentGiftcard", credentials)
  },
};


export default new Vuex.Store({
  plugins:[
    createPersistedState()
  ],
  state,
  mutations,
  getters,
  actions,
  modules: {
    auth,
  }
})
